import { createSlice } from '@reduxjs/toolkit';
import {
  deleteReporter,
  getInstitutionObligations,
  getInstitutionUsersList,
  saveReporter,
  setReporterToObligations,
  updateMainUser,
  updateReporter,
} from './thunks';

const initialState = {
  users: [],
  usersLoading: false,
  usersError: false,
  userFormModalOpen: false,
  userFormModalState: {},
  mainUserModalOpen: false,
  deleteUserConfirmation: { open: false },
  updateMainUserSubmitting: false,
  saveReporterSubmitting: false,
  updateReporterSubmitting: false,
  deleteReporterSubmitting: false,
  institutionObligations: [],
  institutionObligationsLoading: false,
  institutionObligationsError: false,
  userObligations: [],
  resetObligationsModalOpen: false,
  obligationsToReset: [],
  setReporterToObligationsSubmitting: false,
  chosenUserToSet: null
};

const slice = createSlice({
  name: 'users',
  initialState: initialState,
  reducers: {
    resetState: () => initialState,
    toggleUserFormModal: (state, { payload }) => {
      state.userFormModalOpen = !state.userFormModalOpen;
      state.userFormModalState = payload;
    },
    toggleMainUserModal: state => {
      state.mainUserModalOpen = !state.mainUserModalOpen;
      if (!state.mainUserModalOpen) state.userObligations = [];
    },
    setDeleteUserConfirmation: (state, { payload }) => {
      state.deleteUserConfirmation = payload;
    },
    setInstitutionObligations: (state, { payload }) => {
      state.institutionObligations = payload;
    },
    setUserObligations: (state, { payload }) => {
      state.userObligations = payload;
    },
    openObligationsResettingModal: (state, { payload }) => {
      state.obligationsToReset = payload;
      state.resetObligationsModalOpen = true
    },
    closeObligationsResettingModal: state => {
      state.obligationsToReset = [];
      state.chosenUserToSet = null;
      state.resetObligationsModalOpen = false
    },
    setChosenUserToSet: (state, { payload }) => {
      state.chosenUserToSet = payload;
    }
  },
  extraReducers: {
    [getInstitutionUsersList.fulfilled]: (state, { payload }) => {
      state.users = payload;
      state.usersLoading = false;
      state.usersError = false;
    },
    [getInstitutionUsersList.pending]: state => {
      state.usersLoading = true;
      state.usersError = false;
    },
    [getInstitutionUsersList.rejected]: state => {
      state.usersLoading = false;
      state.usersError = true;
    },
    [updateMainUser.fulfilled]: state => {
      state.updateMainUserSubmitting = false;
    },
    [updateMainUser.pending]: state => {
      state.updateMainUserSubmitting = true;
    },
    [updateMainUser.rejected]: state => {
      state.updateMainUserSubmitting = false;
    },
    [saveReporter.fulfilled]: state => {
      state.saveReporterSubmitting = false;
    },
    [saveReporter.pending]: state => {
      state.saveReporterSubmitting = true;
    },
    [saveReporter.rejected]: state => {
      state.saveReporterSubmitting = false;
    },
    [updateReporter.fulfilled]: state => {
      state.updateReporterSubmitting = false;
    },
    [updateReporter.pending]: state => {
      state.updateReporterSubmitting = true;
    },
    [updateReporter.rejected]: state => {
      state.updateReporterSubmitting = false;
    },
    [deleteReporter.fulfilled]: state => {
      state.deleteReporterSubmitting = false;
    },
    [deleteReporter.pending]: state => {
      state.deleteReporterSubmitting = true;
    },
    [deleteReporter.rejected]: state => {
      state.deleteReporterSubmitting = false;
    },
    [getInstitutionObligations.fulfilled]: (state, { payload }) => {
      state.institutionObligations = payload
      state.institutionObligationsLoading = false;
      state.institutionObligationsError = false;
    },
    [getInstitutionObligations.pending]: state => {
      state.institutionObligations = []
      state.institutionObligationsLoading = false;
      state.institutionObligationsError = false;
    },
    [getInstitutionObligations.rejected]: state => {
      state.institutionObligations = []
      state.institutionObligationsLoading = false;
      state.institutionObligationsError = false;
    },
    [setReporterToObligations.fulfilled]: state => {
      state.setReporterToObligationsSubmitting = false;
    },
    [setReporterToObligations.pending]: state => {
      state.setReporterToObligationsSubmitting = true;
    },
    [setReporterToObligations.rejected]: state => {
      state.setReporterToObligationsSubmitting = false;
    },
  },
});

export const {
  resetState,
  setUsersSort,
  setUsersTableCurrentPage,
  setUsersTablePageSize,
  toggleUserFormModal,
  toggleMainUserModal,
  setDeleteUserConfirmation,
  setInstitutionObligations,
  setUserObligations,
  openObligationsResettingModal,
  closeObligationsResettingModal,
  setChosenUserToSet
} = slice.actions;

export default slice.reducer;
